module.exports = __webpack_public_path__ + "static/media/29DUNON16.4da6eec9.jpg";